export const
    gtmCompId = 'gtm',
    gaCompId = 'ga';